import z from "zod";
import { availableVectorStoreProviders } from "../../../types/providers/vector-store-provider";

export const availableVectorStoreProvidersValidator = z.object({
    VECTOR_STORE_PROVIDER: z.enum(availableVectorStoreProviders).default("azure"),
})

export const azureVectorStoreProviderValidator = z.object({
  AZURE_SEARCH_SERVICE_NAME: z.string().min(1, "required").optional(),
  AZURE_SEARCH_API_KEY: z.string().min(1, "required").optional(),
  AZURE_SEARCH_INDEX_NAME: z.string().min(1, "required").optional(),
});

export const milvusVectorStoreProviderValidator = z.object({
  MILVUS_HOST: z.string().min(1, "required").optional(),
  MILVUS_PORT: z.number().min(1).max(65535).optional(),
  MILVUS_USERNAME: z.string().optional(),
  MILVUS_PASSWORD: z.string().optional(),
  MILVUS_DATABASE: z.string().optional(),
  MILVUS_COLLECTION_NAME: z.string().min(1, "required").optional(),
});
